import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchApi, fetchTE } from 'utils/request';

export type NewPasswordPayload = {
  old_password: string;
  password: string;
};

export type UserBody = {
  info?: {
    user_id?: string;
    first_name?: string;
    last_name?: string;
    company_name?: string;
    country?: string;
    job_role?: string;
    job_title?: string;
    state?: string;
    intention?: string;
    referral_source?: string;
    visibility?: CF.API.Visibility;
    image?: CF.API.Image;
  };
  pass?: NewPasswordPayload;
  action?: { op: 'merge' | 'overwrite' | 'delete' };
};

export const updateUserProfileTE = <E = CF.API.ApiError>(
  { userId, body }: { userId?: string; body: UserBody },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Users.GetUserMeResponse> =>
  fetchTE<CF.API.Users.GetUserMeResponse, E>(
    {
      path: `/api/_api/v2/users/${userId}`,
      method: 'PATCH',
      body,
    },
    onRejected,
  );

export const apiUpdateUserProfile = ({ userId, body }: { userId?: string; body: UserBody }): Promise<CF.API.Users.GetUserMeResponse> =>
  fetchApi<CF.API.Users.GetUserMeResponse>({
    path: `/api/_api/v2/users/${userId}`,
    method: 'PATCH',
    body,
  });
